import React from "react";

const LOGO_URL = "/logos/official/infocityjobs.png";
/* Full PNG canvas is 1200x320 but the visible logo (icon + wordmark) only
   occupies a content window of 859x218 starting at x=26,y=50 — same template
   used across all InfoCity portal logos (see config/infocity-network.js
   `logoContentWidth`). Cropping to that window (instead of rendering the raw
   PNG with `object-contain`, which includes the transparent padding) lets us
   control the logo's real VISUAL height precisely. */
const CONTENT_WIDTH = 859;
const CONTENT_HEIGHT = 218;
const CONTENT_X = 26;
const CONTENT_Y = 50;
const CANVAS_WIDTH = 1200;
const CANVAS_HEIGHT = 320;

const fullImgWidthPct = (CANVAS_WIDTH / CONTENT_WIDTH) * 100;
const fullImgHeightPct = (CANVAS_HEIGHT / CONTENT_HEIGHT) * 100;
const leftOffsetPct = -(CONTENT_X / CONTENT_WIDTH) * 100;
const topOffsetPct = -(CONTENT_Y / CONTENT_HEIGHT) * 100;

/** Shared InfoCityJobs wordmark — takes an explicit `height` so any two call
 *  sites using the same value render at EXACTLY the same visual scale. */
export function BrandLogo({ height = "34px", className = "", testId }) {
  return (
    <div
      data-testid={testId}
      className={className}
      style={{
        height,
        aspectRatio: `${CONTENT_WIDTH} / ${CONTENT_HEIGHT}`,
        position: "relative",
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      <img
        src={LOGO_URL}
        alt="InfoCityJobs"
        style={{
          position: "absolute",
          top: `${topOffsetPct}%`,
          left: `${leftOffsetPct}%`,
          width: `${fullImgWidthPct}%`,
          height: `${fullImgHeightPct}%`,
          maxWidth: "none",
          display: "block",
        }}
      />
    </div>
  );
}
